/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const MoveLeftRightIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Move Left Right',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M6.311 10.483A1 1 0 0 1 8 11.2V14h6v6H8v2.778a1.006 1.006 0 0 1-1.707.722L0 17ZM29.707 10.5a1.006 1.006 0 0 0-1.707.722V14h-6v6h6v2.8a1 1 0 0 0 1.689.715L36 17Z"
    />
    <rect height="30" rx="1" ry="1" width="4" x="16" y="2" />
  </svg>`;
};
